import { Suspense } from 'react';
import { Navigate, useParams } from 'react-router-dom';
import Shimmer from '~/components/Shimmer';
import { ClientSideMenu } from '~/features/ClientSideMenu';
import { EditBranchForm } from '~/features/EditBranchForm';
import { EditBranchFormHeader } from '~/features/EditBranchFormHeader';
import { ROUTES } from '~/utils/routes';
import styles from '../../styles.module.scss';

export const Screen: React.FC = () => {
  const { id = '' } = useParams<{ id: string }>();

  const branchId = Number.parseInt(id, 10);
  if (Number.isNaN(branchId)) {
    return <Navigate to={ROUTES.BRANCHES.INDEX} replace />;
  }

  return (
    <div className={styles.screen}>
      <ClientSideMenu />
      <div className={styles.content}>
        <Suspense fallback={<Shimmer />}>
          <EditBranchFormHeader branchId={branchId} />
          <main className={styles.body}>
            <EditBranchForm branchId={branchId} />
          </main>
        </Suspense>
      </div>
    </div>
  );
};
